<template>
  <ul class="breadcrumbs">
    <li v-for="link in links" :key="link.text"><a :href="link.href">{{link.text}}</a></li>
  </ul>
</template>
<script>
export default {
  name: "WellsBreadcrumb",
  props: {
    links : {
      type: Array,
      default(){
        return [];
      }
    }
  }
};
</script>
